import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React, { useEffect, useState } from "react";

interface MenuItemProps {
  id: number;
  key: string;
  value: string;
}

export const Menu = ({
  label,
  items,
  getValue,
  width,
  val,
}: {
  label: string;
  getValue: (val: string) => void;
  items: MenuItemProps[];
  val?: string | number;
  width?: string;
}) => {
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (val) {
      setValue(val.toString());
    }
  }, [val]);

  const handleChange = (event: SelectChangeEvent) => {
    const val = event.target.value as string;
    setValue(val);
    getValue(val);
  };
  return (
    <FormControl fullWidth sx={{ marginRight: "8px" }}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label={label}
        onChange={handleChange}
        size="small"
        sx={{ width }}
      >
        {items.map((item: MenuItemProps) => {
          return (
            <MenuItem key={item.id} value={item.value}>
              {item.key}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
